import './brokerRoboExpirationMessage.scss';
// @vendors
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const { FormattedText } = require('core/i18n').i18n;

// @components
import { OKButton } from 'commonsComponents/OKButton';

// @assets
import iconExpirationTI from 'assets/icons/icon-expiration-ti.svg';

// @constants
import { SHOW_SUITABILITY_TEST_EXPIRATION_NOTICE } from 'constants/flagBasedFeatures';

const BrokerRoboExpirationMessage = ({ immCheckStatus, immFlagBasedFeatures, history }) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const expirationDate = immCheckStatus.get('expirationDate');
    const activeRoboCustomer = immCheckStatus.get('activeRoboCustomer');
    if (expirationDate && activeRoboCustomer && immFlagBasedFeatures.get(SHOW_SUITABILITY_TEST_EXPIRATION_NOTICE)) {
      const currentDate = moment();
      const popUpExpirationDate = moment(expirationDate).add(1, 'month');
      if (popUpExpirationDate.isBefore(currentDate) && !isOpen) {
        const lastShownDate = localStorage.getItem('roboExpirationPopupLastShownDate');
        const popupCount = parseInt(localStorage.getItem('roboExpirationPopupCount')) || 0;

        if (lastShownDate) {
          const lastDate = moment(lastShownDate);
          if (currentDate.isSame(lastDate, 'month') && currentDate.isSame(lastDate, 'year')) {
            if (popupCount <= 2) {
              setIsOpen(true);
              localStorage.setItem('roboExpirationPopupCount', popupCount + 1);
            }
          } else {
            localStorage.setItem('roboExpirationPopupLastShownDate', currentDate.toISOString());
            localStorage.setItem('roboExpirationPopupCount', 1);
            setIsOpen(true);
          }
        } else {
          localStorage.setItem('roboExpirationPopupLastShownDate', currentDate.toISOString());
          localStorage.setItem('roboExpirationPopupCount', 1);
          setIsOpen(true);
        }
      }
    }
  }, [immCheckStatus]);

  if (!isOpen) {
    return null;
  }
  return (
    <div className="broker-robo-expiration-pop-up__background">
      <div className="broker-robo-expiration-pop-up__container">
        <div className="broker-robo-expiration-pop-up__cross">
          <div
            onClick={() => setIsOpen(false)}
            className="broker-robo-expiration-pop-up__cross-icon icon-cerrar"
          />
        </div>
        <div className="broker-robo-expiration-pop-up__content-container">
          <div className="broker-robo-expiration-pop-up__content-left">
            <img
              className="broker-robo-expiration-pop-up__content-left-icon"
              src={iconExpirationTI}
            />
          </div>
          <div className="broker-robo-expiration-pop-up__content-right">
            <div className="broker-robo-expiration-pop-up__content-text">
              <div className="broker-robo-expiration-pop-up__content-text-title">
                <FormattedText value="raTestExpiredModal-title" />
              </div>
              <div className="broker-robo-expiration-pop-up__content-text-subtitle">
                <FormattedText value="raTestExpiredModal-description" />
              </div>
            </div>
            <div className="broker-robo-expiration-pop-up__content-cta">
              <OKButton
                modifier="primary"
                onClick={() => {
                  history.push('/myprofile/robo/testStatus');
                  setIsOpen(false);
                }}
              >
                <FormattedText value="raTestExpiredModal-cta" />
              </OKButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
BrokerRoboExpirationMessage.propTypes = {
  immCheckStatus: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

module.exports = connect(
  state => ({
    immCheckStatus: state.raCheckStatus,
    immFlagBasedFeatures: state.flagBasedFeatures,
  }),
  {}
)(withRouter(BrokerRoboExpirationMessage));
